import Vue from 'vue'
import VueRouter from 'vue-router'
import DashboardPlugin from './dashboard-plugin'
import axios from 'axios'
import VuePaginate from 'vuejs-paginate'
import VueSweetalert2 from 'vue-sweetalert2';
import vmodal from 'vue-js-modal'
import ImageUploader from 'vue-image-upload-resize'
// Plugins
import App from './App.vue'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import ConfigService from '@/services/ConfigService'

// router setup
import routes from './routes/routes'
import { http } from './services/HttpService'
import money from 'v-money'
import JsonExcel from 'vue-json-excel'

import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'vue-select/dist/vue-select.css';
import VueSelect from 'vue-select'
import vueDebounce from 'vue-debounce'

import 'sweetalert2/dist/sweetalert2.min.css';

const moment = require('moment')
require('moment/locale/pt-br')

Vue.use(require('vue-moment'), {
    moment
})

// register directive v-money and component <money>
Vue.use(money, {
  decimal: ',',
  thousands: '.',
  prefix: 'R$ ',
  suffix: '',
  precision: 2,
  masked: false
})

const VueInputMask = require('vue-inputmask').default

// plugin setup
Vue.component('downloadExcel', JsonExcel)
Vue.component('paginate', VuePaginate)
Vue.use(VueSweetalert2);
Vue.use(vmodal) 
Vue.use(VueInputMask)
Vue.use(VueRouter)
Vue.use(DashboardPlugin)
Vue.use(Loading);
Vue.use(require('vue-moment'));
Vue.use(ImageUploader);
Vue.use(vueDebounce);
Vue.component('v-select', VueSelect);
Vue.filter('reverse', function(value) {
  // slice to make a copy of array, then reverse the copy
  return value.slice().reverse();
});

Vue.filter('currencyBrl', function (value, args) {
  if (value === undefined || value === '' || value === null) {
      return;
  }

  // Bug Fix no toFixed
  value = parseFloat(value);
  var currency_format = '';
  if (args == true || args == 'true') {
      currency_format = 'R$ ';
  }
  return currency_format + value.toFixed(2).replace(".", ",").replace(/(\d)(?=(\d{3})+\,)/g, '$1.');
})

http.interceptors.response.use(undefined, function (error) {
  if(error.response.status === 401) {
     localStorage.clear()
     Object.assign(http.defaults, {headers: {}})
     router.replace('/login');
  }
  throw(error)
})

if(localStorage.getItem("token")) {
  try {
    let user = JSON.parse(localStorage.getItem('user'))
    window.accessLevel = user.access_level
  } catch(err) {

  }
  ConfigService.fetch()
}

//==================================================================================
// Chat
//==================================================================================
let interval = setInterval(() => {
  try {
    let token = localStorage.getItem('token')
    let idi = localStorage.getItem('current_idi')
    console.log("[DEBUG CHAT] Carregando dados da empresa no chat")


    if(window.fcWidget && token && idi) {
      let instalacao = JSON.parse(localStorage.getItem('stores')).find(x => x.idi == idi)

      if(instalacao) {
        console.log("[DEBUG CHAT] Setting information on fcWidget")

        window.fcWidget.setExternalId(instalacao.idi);
        window.fcWidget.user.setFirstName( "(" + instalacao.idi + ") DW - " + instalacao.apelido);
        window.fcWidget.user.setEmail(instalacao.email);
        window.fcWidget.user.setProperties({
          plan: "Yooga Desktop Web",                 // meta property 1
          status: "Active"                // meta property 2
        });

        // window.fcWidget.open();

        console.log("[DEBUG CHAT] Clearing Interval")
        clearInterval(interval)
      }
    }
  } catch(e) {
    clearInterval(interval)
    console.log(e)
    console.log("[DEBUG CHAT] Falha crítica ao iniciar o chat")
  }
}, 2000)

var baseDir = "/";

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active',
  mode: 'history',
  base: baseDir,
});

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  // If no subsequent Middleware exists,
  // the default `next()` callback is returned.
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    // Run the default Vue Router `next()` callback first.
    context.next(...parameters);
    // Then run the subsequent Middleware with a new
    // `nextMiddleware()` callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
    ? to.meta.middleware
    : [to.meta.middleware];

    const context = {
      from,
      next,
      router,
      to,
    };
    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({ ...context, next: nextMiddleware });
  }

  return next();
});

Chart.defaults.global.defaultFontFamily = 'Poppins'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router
});

/* We import element-ui variables at the end so they can override the default element-ui colors */
import './assets/sass/element_variables.scss'
